function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-926.000000, -201.000000)",
  fill: "#9B9B9B",
  fillRule: "nonzero"
}, React.createElement("g", {
  transform: "translate(926.000000, 201.000000)"
}, React.createElement("g", null, React.createElement("path", {
  d: "M12.8596879,7.96493617 C12.8596879,7.62791489 12.5899574,7.35489362 12.2574752,7.35489362 L8.57225532,7.35489362 L8.57225532,3.67512057 L8.57225532,3.67500709 C8.57225532,3.33685106 8.29787234,3.06258156 7.95994326,3.06258156 C7.62178723,3.06258156 7.34740426,3.33685106 7.34740426,3.67500709 L7.34740426,7.96255319 C7.34740426,8.3008227 7.62178723,8.5750922 7.95994326,8.5750922 L12.2578156,8.5750922 C12.5899574,8.5750922 12.8596879,8.30195745 12.8596879,7.96493617 M14.6987801,7.96107801 C14.6987801,11.6828369 11.682156,14.6999149 7.96119149,14.6999149 C4.24,14.6999149 1.22360284,11.6828369 1.22360284,7.96107801 C1.22360284,4.23931915 4.24,1.22224113 7.96119149,1.22224113 C11.682156,1.22224113 14.6987801,4.23931915 14.6987801,7.96107801 M15.922156,7.96107801 C15.922156,3.56425532 12.3579007,0 7.96119149,0 C3.56425532,0 0,3.56425532 0,7.96107801 C0,12.3579007 3.56425532,15.922156 7.96119149,15.922156 C12.3579007,15.922156 15.922156,12.3579007 15.922156,7.96107801"
})))));

const SvgClockIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "16px",
  height: "16px",
  viewBox: "0 0 16 16",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgClockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock-icon.16f0303b.svg";
export { ForwardRef as ReactComponent };